import { appFetch } from './fetch';
import host from './host';
import auth from './auth';

export const getPricesList  = async () => {
    const url = `${host}/prices_lists/get_all`;
    return await appFetch({ url, auth: auth.getToken(), method: 'GET' });
};

export const createPricesList = async data => {
    const url = `${host}/spare_parts/prices/create`;
    return await appFetch({ url, auth: auth.getToken(), body: JSON.stringify(data), method: 'POST' })
}

export const updatePricesList = async (id, data) => {
    const url = `${host}/price_list/update/${id}`;
    return await appFetch({ url, auth: auth.getToken(), body: JSON.stringify(data), method: 'PUT' })
}

export const defaultPriceLst = async () => {
    const url = `${host}/price_lists/default`;
    return await appFetch({ url, auth: auth.getToken(), method: 'GET' });
};